export const FETCH_EQUIPMENT_USAGE = '@@material/fetch-equipment-usage';
export const FETCH_EQUIPMENT_USAGE_SUCCESS = '@@material/fetch-equipment-usage-success';
export const FETCH_EQUIPMENT_USAGE_FAILURE = '@@material/fetch-equipment-usage-failure';
